// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leaderboard-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
}

.leaderboard-header {
  text-align: center;
  margin-bottom: 2rem;
}

.leaderboard-header h1 {
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
  color: #2d3748;
}

.leaderboard-header p {
  font-size: 1.1rem;
  color: #718096;
  margin-bottom: 1.5rem;
}

.user-rank-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 1.5rem;
  border-radius: 12px;
  margin: 1.5rem auto;
  max-width: 400px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.user-rank-card h3 {
  margin: 0 0 1rem 0;
  font-size: 1.2rem;
  font-weight: 600;
}

.rank-info {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.rank-number {
  font-size: 2rem;
  font-weight: bold;
  color: #ffd700;
}

.tasks-count {
  font-size: 1.1rem;
  font-weight: 500;
}

.percentile {
  background: rgba(255, 255, 255, 0.2);
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 500;
}

.rank-info.hidden .hidden-status {
  background: rgba(255, 255, 255, 0.2);
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.9rem;
  opacity: 0.8;
}

.auth-prompt {
  background: #f7fafc;
  border: 2px dashed #cbd5e0;
  padding: 1rem;
  border-radius: 8px;
  margin: 1rem auto;
  max-width: 400px;
}

.auth-prompt p {
  margin: 0;
  color: #4a5568;
  font-weight: 500;
}

.leaderboard-stats {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
}

.stat {
  text-align: center;
}

.stat-number {
  display: block;
  font-size: 1.8rem;
  font-weight: bold;
  color: #2d3748;
}

.stat-label {
  display: block;
  font-size: 0.9rem;
  color: #718096;
  margin-top: 0.25rem;
}

.last-updated {
  font-size: 0.85rem;
  color: #a0aec0;
  text-align: center;
}

.empty-leaderboard {
  text-align: center;
  padding: 3rem 1rem;
  background: #f7fafc;
  border-radius: 12px;
  margin: 2rem 0;
}

.empty-leaderboard h3 {
  font-size: 1.5rem;
  color: #4a5568;
  margin-bottom: 0.5rem;
}

.empty-leaderboard p {
  color: #718096;
  font-size: 1rem;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  margin: 2rem 0;
  flex-wrap: wrap;
}

.page-button {
  background: #edf2f7;
  border: 1px solid #e2e8f0;
  color: #4a5568;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  font-weight: 500;
}

.page-button:hover:not(:disabled) {
  background: #e2e8f0;
  border-color: #cbd5e0;
}

.page-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-info {
  margin: 0 1rem;
  font-weight: 500;
  color: #4a5568;
}

.leaderboard-actions {
  text-align: center;
  margin-top: 2rem;
}

.refresh-button {
  background: #4299e1;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;
}

.refresh-button:hover {
  background: #3182ce;
}

.loading-container,
.error-container {
  text-align: center;
  padding: 3rem 1rem;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #e2e8f0;
  border-top: 4px solid #4299e1;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error-container h2 {
  color: #e53e3e;
  margin-bottom: 1rem;
}

.error-container p {
  color: #718096;
  margin-bottom: 1.5rem;
}

.retry-button {
  background: #e53e3e;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
}

.retry-button:hover {
  background: #c53030;
}

/* Responsive design */
@media (max-width: 768px) {
  .leaderboard-page {
    padding: 1rem;
  }

  .leaderboard-header h1 {
    font-size: 2rem;
  }

  .leaderboard-stats {
    gap: 1rem;
  }

  .rank-info {
    justify-content: center;
  }

  .pagination {
    gap: 0.25rem;
  }

  .page-button {
    padding: 0.5rem 0.75rem;
    font-size: 0.9rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/LeaderboardPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;AACF","sourcesContent":[".leaderboard-page {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n.leaderboard-header {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.leaderboard-header h1 {\n  font-size: 2.5rem;\n  font-weight: bold;\n  margin-bottom: 0.5rem;\n  color: #2d3748;\n}\n\n.leaderboard-header p {\n  font-size: 1.1rem;\n  color: #718096;\n  margin-bottom: 1.5rem;\n}\n\n.user-rank-card {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 1.5rem;\n  border-radius: 12px;\n  margin: 1.5rem auto;\n  max-width: 400px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.user-rank-card h3 {\n  margin: 0 0 1rem 0;\n  font-size: 1.2rem;\n  font-weight: 600;\n}\n\n.rank-info {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.rank-number {\n  font-size: 2rem;\n  font-weight: bold;\n  color: #ffd700;\n}\n\n.tasks-count {\n  font-size: 1.1rem;\n  font-weight: 500;\n}\n\n.percentile {\n  background: rgba(255, 255, 255, 0.2);\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.rank-info.hidden .hidden-status {\n  background: rgba(255, 255, 255, 0.2);\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.9rem;\n  opacity: 0.8;\n}\n\n.auth-prompt {\n  background: #f7fafc;\n  border: 2px dashed #cbd5e0;\n  padding: 1rem;\n  border-radius: 8px;\n  margin: 1rem auto;\n  max-width: 400px;\n}\n\n.auth-prompt p {\n  margin: 0;\n  color: #4a5568;\n  font-weight: 500;\n}\n\n.leaderboard-stats {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 2rem;\n  margin-bottom: 2rem;\n  flex-wrap: wrap;\n}\n\n.stat {\n  text-align: center;\n}\n\n.stat-number {\n  display: block;\n  font-size: 1.8rem;\n  font-weight: bold;\n  color: #2d3748;\n}\n\n.stat-label {\n  display: block;\n  font-size: 0.9rem;\n  color: #718096;\n  margin-top: 0.25rem;\n}\n\n.last-updated {\n  font-size: 0.85rem;\n  color: #a0aec0;\n  text-align: center;\n}\n\n.empty-leaderboard {\n  text-align: center;\n  padding: 3rem 1rem;\n  background: #f7fafc;\n  border-radius: 12px;\n  margin: 2rem 0;\n}\n\n.empty-leaderboard h3 {\n  font-size: 1.5rem;\n  color: #4a5568;\n  margin-bottom: 0.5rem;\n}\n\n.empty-leaderboard p {\n  color: #718096;\n  font-size: 1rem;\n}\n\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 2rem 0;\n  flex-wrap: wrap;\n}\n\n.page-button {\n  background: #edf2f7;\n  border: 1px solid #e2e8f0;\n  color: #4a5568;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s;\n  font-weight: 500;\n}\n\n.page-button:hover:not(:disabled) {\n  background: #e2e8f0;\n  border-color: #cbd5e0;\n}\n\n.page-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.page-info {\n  margin: 0 1rem;\n  font-weight: 500;\n  color: #4a5568;\n}\n\n.leaderboard-actions {\n  text-align: center;\n  margin-top: 2rem;\n}\n\n.refresh-button {\n  background: #4299e1;\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n\n.refresh-button:hover {\n  background: #3182ce;\n}\n\n.loading-container,\n.error-container {\n  text-align: center;\n  padding: 3rem 1rem;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #e2e8f0;\n  border-top: 4px solid #4299e1;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 1rem;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.error-container h2 {\n  color: #e53e3e;\n  margin-bottom: 1rem;\n}\n\n.error-container p {\n  color: #718096;\n  margin-bottom: 1.5rem;\n}\n\n.retry-button {\n  background: #e53e3e;\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.retry-button:hover {\n  background: #c53030;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .leaderboard-page {\n    padding: 1rem;\n  }\n\n  .leaderboard-header h1 {\n    font-size: 2rem;\n  }\n\n  .leaderboard-stats {\n    gap: 1rem;\n  }\n\n  .rank-info {\n    justify-content: center;\n  }\n\n  .pagination {\n    gap: 0.25rem;\n  }\n\n  .page-button {\n    padding: 0.5rem 0.75rem;\n    font-size: 0.9rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
